<template>
    <div>
        <div style="padding: 0 20px">
            <!--    新增角色按钮-->
            <div class="top" style="font-size: 14px;">
                <div >
                    <div style="width: 70px">支持剂型：</div>
                </div>
                <div>
                    <div>
                        <el-checkbox v-model="ZYKL.ZYKL">中药颗粒</el-checkbox>
                    </div>
                    <div style="display:flex;flex-direction: row;margin: 10px 50px;">
                        <span style="color: rgba(102,102,102,1);">支持规格：</span>
                        <el-checkbox-group :disabled="!ZYKL.ZYKL" v-model="ZYKL.unit">
                            <el-checkbox label="KE">克装</el-checkbox>
                            <el-checkbox label="DAI">袋装</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="line"></div>
                    <div>
                        <el-checkbox v-model="ZYYP.ZYYP">中药饮片</el-checkbox>
                    </div>
                    <div style="display:flex;flex-direction: row;margin: 10px 50px;">
                        <span style="color: rgba(102,102,102,1);">支持规格：</span>
                        <el-checkbox-group v-model="ZYYP.unit">
                            <el-checkbox :disabled="true" label="KE">克装</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div style="display:flex;flex-direction: row;margin: 10px 50px;">
                        <span style="color: rgba(102,102,102,1);">代煎服务：</span>
                        <el-radio-group v-model="ZYYP.isServer" :disabled="!ZYYP.ZYYP">
                          <el-radio :label="0">代煎</el-radio>
                          <el-radio :label="1">仅代煎</el-radio>
                          <el-radio :label="2">不代煎</el-radio>
                        </el-radio-group>
<!--                        <el-checkbox :disabled="!ZYYP.ZYYP" v-model="ZYYP.isServer">代煎</el-checkbox>-->
                    </div>
                    <div style="display:flex;flex-direction: row;margin: 10px 50px;">
                        <span style="color: rgba(102,102,102,1);margin-top: 5px">代煎费用：</span>
                        <el-input :disabled="ZYYP.isServer === '1'" v-model="ZYYP.workMoney" style="width: 64px;" size="small"></el-input>
                        <span style="color: rgba(102,102,102,1);margin: 5px 10px">元/每剂</span>
                    </div>
                    <div class="line"></div>
<!--                    <div>-->
<!--                        <el-checkbox v-model="SJGF.SJGF">四级膏方</el-checkbox>-->
<!--                    </div>-->
<!--                    <div style="display:flex;flex-direction: row;margin: 10px 50px;">-->
<!--                        <span style="color: rgba(102,102,102,1);">支持规格：</span>-->
<!--                        <el-checkbox-group v-model="SJGF.unit">-->
<!--                            <el-checkbox :disabled="true" label="KE">克装</el-checkbox>-->
<!--                        </el-checkbox-group>-->
<!--                    </div>-->
<!--                    <div class="line"></div>-->
<!--                    <div>-->
<!--                        <el-checkbox v-model="ZYWJ.ZYWJ">中药丸剂</el-checkbox>-->
<!--                    </div>-->
<!--                    <div style="display:flex;flex-direction: row;margin: 10px 50px;">-->
<!--                        <span style="color: rgba(102,102,102,1);">支持规格：</span>-->
<!--                        <el-checkbox-group v-model="ZYWJ.unit">-->
<!--                            <el-checkbox :disabled="true" label="KE">克装</el-checkbox>-->
<!--                        </el-checkbox-group>-->
<!--                    </div>-->
<!--                    <div class="line"></div>-->
                    <div style="margin-top: 20px">
                        <el-button style="width: 96px" @click="getData">取消修改</el-button>
                        <el-button style="width: 68px;" type="primary" @click="saveSet">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                ZYKL: {
                    ZYKL: false,
                    unit: ['KE']
                },
                ZYYP: {
                    ZYYP: false,
                    unit: ['KE'],
                    isServer: false,
                    workMoney: '',
                },
                SJGF: {
                    SJGF: false,
                    unit: ['KE'],
                },
                ZYWJ: {
                    ZYWJ: false,
                    unit: ['KE'],
                }
            }
        },
        methods: {
            // 获取列表数据
            getData() {
                this.axios.get('/api-b/10008/100138',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        let medicineTypeList = res.data.data.medicineTypeList
                        for (let i=0;i<medicineTypeList.length;i++) {
                            if (medicineTypeList[i].typeCode === 'ZYKL') {
                                this.ZYKL.ZYKL = true
                            } else if (medicineTypeList[i].typeCode === 'ZYYP') {
                                this.ZYYP.ZYYP = true
                                this.ZYYP.unit = ['KE']
                                this.ZYYP.isServer = res.data.data.isServer
                                if (res.data.data.isServer !== '1') {
                                    this.ZYYP.workMoney = medicineTypeList[i].workMoney
                                }
                            } else if (medicineTypeList[i].typeCode === 'SJGF') {
                                this.SJGF.unit = ['KE']
                                this.SJGF.SJGF = true
                            } else if (medicineTypeList[i].typeCode === 'ZYWJ') {
                                this.ZYWJ.unit = ['KE']
                                this.ZYWJ.ZYWJ = true
                            }
                        }
                        let pharmacyUnitList = res.data.data.pharmacyUnitList
                        for (let i=0;i<pharmacyUnitList.length;i++) {
                            if (pharmacyUnitList[i].typeCode === 'ZYKL') {
                                this.ZYKL.unit.push(pharmacyUnitList[i].unit)
                            }
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            saveSet() {
                if (!(this.ZYKL.ZYKL || this.ZYYP.ZYYP || this.SJGF.SJGF || this.ZYWJ.ZYWJ)) {
                    this.$message.error('请至少选择一种剂型')
                } else {
                    let params = {}
                    if (this.ZYKL.ZYKL) {
                        params.ZYKL = {
                            unit: this.ZYKL.unit
                        }
                    }
                    if (this.ZYYP.ZYYP) {
                        if (this.ZYYP.isServer !== '1') {
                            params.ZYYP = {
                                unit: this.ZYYP.unit,
                                isServer: this.ZYYP.isServer,
                                workMoney: this.ZYYP.workMoney,
                            }
                        } else {
                            params.ZYYP = {
                                unit: this.ZYYP.unit,
                                isServer: this.ZYYP.isServer,
                            }
                        }
                    }
                    if (this.SJGF.SJGF) {
                        params.SJGF = {
                            unit: this.SJGF.unit
                        }
                    }
                    if (this.ZYWJ.ZYWJ) {
                        params.ZYWJ = {
                            unit: this.ZYWJ.unit
                        }
                    }
                    this.axios.put('/api-b/10008/100092',params,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
            },
        },
        watch: {

        },
        created() {
            this.getData()
        }
    }
</script>


<style>
    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }
    .el-button--primary:hover {
        background:rgba(120,180,255,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
    .el-button--primary:focus {
        background:rgba(57,129,221,1)!important;
        color: #FFFFFF!important;
        border: none!important;
    }
</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 12px;
        height: 52px;
    }
    .line {
        border:dashed #CCCCCC;
        border-width:0 0 1px 0;
        width: 1400px;
        margin-bottom: 10px
    }
</style>